export default __webpack_public_path__ + "static/media/LogoAlt.093e5730.png";